import { Component, OnInit, signal } from '@angular/core';
import { Router,RouterModule } from '@angular/router';
import { AdvisorService } from '../../_services/advisor/advisor.service';
import { ToastService } from '../../_services/toast.service';
import { SlicePipe } from '@angular/common';
import { LoaderService } from '../../_services/loader.service';

@Component({
  selector: 'app-advisor',
  imports: [RouterModule,SlicePipe],
  templateUrl: './advisor.component.html',
  styleUrl: './advisor.component.scss',
})
export class AdvisorComponent implements OnInit {
  advisorList:any = signal([])
  allAdvisors:any = []
  constructor(
    private router: Router, 
    private readonly _AS: AdvisorService,
    private readonly showNotification : ToastService,
     private readonly loaderService :LoaderService) {}

  ngOnInit(): void {
    this.getAllAdvisor();
  }
  getAllAdvisor() {
    this.loaderService.show();
    this._AS.advisor().subscribe({
      next: (res: any) => {
        this.allAdvisors = res.data; // Save the full data
        this.advisorList.set(res.data)
        this.showNotification.success('Advisors fetched successfully');
      },
      error: (err) => {
        this.loaderService.hide()
        this.showNotification.error(err);
      },
      complete: () => {
        this.loaderService.hide()
      },
    });
  }
  deleteAdvisor(id:string) {
    this.loaderService.show();
    this._AS.deleteAdvisor(id).subscribe({
      next: (res: any) => {
        this.showNotification.success(res.message);
        this.getAllAdvisor();
      },
      error: (err) => {
        this.loaderService.hide()
        this.showNotification.error(err);
      },
      complete: () => {
        this.loaderService.hide()
      },
    });
  }
  onSearch(event: any) {
    const query = event.target.value.toLowerCase();
    const filtered = this.allAdvisors.filter((a:any) => 
      a.name.toLowerCase().includes(query) || 
      a.specialization.toLowerCase().includes(query)
    );
    this.advisorList.set(filtered);
  }
  

  viewDetails(advisor: any) {}
  bookAdvisor(advisor: any) {}
  viewProfile(advisor: any) {
    this.router.navigate([`admin/advisor/profile/${advisor.name}/${advisor._id}`]);
  }

  isDeleteModalOpen = false;
  selectedDeleteId: string | null = null;

  openDeleteModal(id: string) {
    this.selectedDeleteId = id;
    this.isDeleteModalOpen = true;
  }

  closeDeleteModal() {
    this.isDeleteModalOpen = false;
    this.selectedDeleteId = null;
  }

  confirmDelete() {
    if (!this.selectedDeleteId) return;

    this.deleteAdvisor(this.selectedDeleteId); // ✅ your existing function
    this.closeDeleteModal();
  }
}
